import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import AddBankCardCategory from "./components/addBankCardCategory";
import { AppSearchSelect } from "../../../components/appComponents";

const BankCardCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);
  const [isActive, setIsActive] = useState(null);

  useEffect(() => {
    getData();
  }, [isActive]);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open]);

  const getData = async () => {
    setLoading(true);
    const response = await Common.ApiService.getInstance().request(
      `GetBankCardCategories${isActive !== null ? `?isactive=${isActive}` : ""}`
    );
    if (response?.data) {
      let responseData = response?.data.map((item) => ({
        ...item,
        isactive: item.isactive ? "Yes" : "No",
      }));
      setData(responseData);
      setLoading(false);
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Bank Card Category?",
      "Delete Bank Card Category"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteBankCardCategory?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData();
      }, 500);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Bank Card Category Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    { title: "Is Active", type: "boolean", isVisible: true, key: "isactive" },
  ];

  // Status filter options
  const statusOptions = [
    { id: null, name: "All Status" },
    { id: true, name: "Active" },
    { id: false, name: "Inactive" },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="md:grid md:grid-cols-5 gap-3 space-y-6 md:space-y-0">
        <AppSearchSelect
          value={isActive}
          onChange={setIsActive}
          placeholder={"Select Status"}
          label={"Status"}
          data={statusOptions}
          className={"mb-5 col-span-1"}
        />
      </div>

      <AdvanceTable
        title={"Bank Card Categories"}
        columns={_thead.filter((item) => item.isVisible)}
        data={{ data: data }}
        getData={getData}
        addButton={() => (
          <AddBankCardCategory
            id={refId}
            onClose={() => getData()}
            open={open}
            setOpen={setOpen}
          />
        )}
        showPagination={false}
        showAddButton
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
      />
    </>
  );
};

export default BankCardCategories;
